import React, {PropTypes} from 'react';

export default function CharacterDetailAttribute({title, text, visualAid}) {
  const visualAidContainer = visualAid ? <div className="visual-aid">{visualAid}</div> : null;
  return (
    <div className="character-detail-attribute">
      <div className="title">{title}</div>
      <div className="content">
        {visualAidContainer}
        <div className="text">{text}</div>
      </div>
    </div>
  );
}

CharacterDetailAttribute.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string.isRequired,
  visualAid: PropTypes.object,
};



// WEBPACK FOOTER //
// ./app/features/characterDetail/components/CharacterDetailAttribute.js